import Payment from "payment";

export type PrefixBand = "none" | "amex" | "diners" | "elo" | "mastercard" | "visa";

const prefixBandArr = ["none", "amex", "diners", "elo", "mastercard", "visa"];

export interface CreditCardProps {
  index?: number;
  bandUrl: string;
  bandName: string;
  value: PrefixBand;
}

export interface BandCreditCardProps {
  cartNumber?: string;
  acceptBands?: string[];
  selectedBand: PrefixBand;
  onSelectBand?: (band: string) => void;
}

export const objectPrefixBands: Record<PrefixBand, CreditCardProps> & {
  [key: string]: CreditCardProps;
} = {
  none: {
    index: 0,
    value: "amex",
    bandName: "American express digital",
    bandUrl: "/assets/images/none-card.png"
  },
  amex: {
    index: 1,
    value: "amex",
    bandName: "American express digital",
    bandUrl: "/assets/images/amex-logo.png"
  },
  diners: {
    index: 2,
    value: "diners",
    bandName: "Diners club international",
    bandUrl: "/assets/images/diners-logo.png"
  },
  elo: {
    index: 3,
    value: "elo",
    bandName: "Elo",
    bandUrl: "/assets/images/elo-logo.png"
  },
  mastercard: {
    index: 4,
    value: "mastercard",
    bandName: "Mastercard",
    bandUrl: "/assets/images/mastercard-logo.png"
  },
  visa: {
    index: 5,
    value: "visa",
    bandName: "Visa",
    bandUrl: "/assets/images/visa-logo.png"
  }
};

export const allBands: CreditCardProps[] = Object.keys(objectPrefixBands).map(
  key => objectPrefixBands[key]
);

export const getCardFlag = (cardNumber: string) => {
  const band = Payment.fns.cardType(cardNumber);
  return prefixBandArr.includes(band) ? band : "none";
};
